import { render, staticRenderFns } from "./NfButton.vue?vue&type=template&id=0c0d957a&scoped=true&"
import script from "./NfButton.vue?vue&type=script&lang=js&"
export * from "./NfButton.vue?vue&type=script&lang=js&"
import style0 from "./NfButton.vue?vue&type=style&index=0&id=0c0d957a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d957a",
  null
  
)

export default component.exports